import { render, staticRenderFns } from "./StatsOverduePayouts.vue?vue&type=template&id=159c606d&"
import script from "./StatsOverduePayouts.vue?vue&type=script&lang=js&"
export * from "./StatsOverduePayouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports